import { render, staticRenderFns } from "./PriceChart.vue?vue&type=template&id=2856a98c&scoped=true"
import script from "./PriceChart.vue?vue&type=script&lang=js"
export * from "./PriceChart.vue?vue&type=script&lang=js"
import style0 from "./PriceChart.vue?vue&type=style&index=0&id=2856a98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2856a98c",
  null
  
)

export default component.exports